var map = {
	"./txt_index-a-s.png": "d9f2",
	"./txt_index-ha-s.png": "6b25",
	"./txt_index-ka-s.png": "0895",
	"./txt_index-ma-s.png": "d499",
	"./txt_index-n-s.png": "257e",
	"./txt_index-na-s.png": "cd6c",
	"./txt_index-ra-s.png": "eaf5",
	"./txt_index-sa-s.png": "4ed6",
	"./txt_index-ta-s.png": "09e7",
	"./txt_index-wa-s.png": "cf60",
	"./txt_index-wo-s.png": "8d42",
	"./txt_index-ya-s.png": "591f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b818";